function wishlistCacheKey(customerId) {
  return customerId ? `kiabi_wishlist_${customerId}` : 'kiabi_wishlist_guest';
}

function readWishlistCache(customerId) {
  const key = wishlistCacheKey(customerId);
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    return [];
  }
}

function writeWishlistCache(customerId, wishlist) {
  const key = wishlistCacheKey(customerId);
  if (!Array.isArray(wishlist)) return;
  try {
    localStorage.setItem(key, JSON.stringify(wishlist));
  } catch (err) {
    // localStorage indisponible (navigation privée, quota...) : on ignore silencieusement
  }
}

// Le cache invité stocke des objets {gid, title, image, url} (pour pouvoir afficher
// la wishlist localement sans appel API) ; le cache client connecté ne stocke que
// des GIDs (renvoyés tels quels par l'API). On normalise pour comparer/afficher.
function wishlistItemGid(item) {
  return typeof item === 'string' ? item : item.gid;
}

function showWishlistGuestModal() {
  const modal = document.getElementById('wishlistGuestModal');
  if (!modal) return;
  modal.hidden = false;
  document.body.classList.add('wishlist-guest-modal-open');
}

// sessionStorage : le compteur repart de 0 à chaque nouvelle session (navigateur/onglet
// fermé puis rouvert), mais survit à un simple refresh de la page.
function maybeShowWishlistGuestModal() {
  let count;
  try {
    count = parseInt(sessionStorage.getItem('kiabi_wishlist_guest_modal_count') || '0', 10) + 1;
    sessionStorage.setItem('kiabi_wishlist_guest_modal_count', String(count));
  } catch (err) {
    return; // sessionStorage indisponible : on ne relance pas la popup
  }

  // 1er ajout de la session, puis tous les 4 ajouts (5e, 9e, 13e...)
  if (count % 4 !== 1) return;

  showWishlistGuestModal();
}

function bindWishlistGuestModalDismiss() {
  const modal = document.getElementById('wishlistGuestModal');
  if (!modal || modal.dataset.bound === 'true') return;
  modal.dataset.bound = 'true';

  modal.querySelectorAll('[data-wishlist-guest-dismiss]').forEach((el) => {
    el.addEventListener('click', () => {
      modal.hidden = true;
      document.body.classList.remove('wishlist-guest-modal-open');
    });
  });
}

function toggleGuestWishlistCache(element, action) {
  const productId = element.dataset.productId;
  const gid = `gid://shopify/Product/${productId}`;
  const list = readWishlistCache(null);

  let next;
  if (action === 'add') {
    next = list.some((item) => wishlistItemGid(item) === gid)
      ? list
      : [...list, {
          gid,
          title: element.dataset.productTitle || '',
          image: element.dataset.productImage || '',
          url: element.dataset.productUrl || '',
          price: element.dataset.productPrice || ''
        }];
  } else {
    next = list.filter((item) => wishlistItemGid(item) !== gid);
  }

  writeWishlistCache(null, next);
}

function applyWishlistCache(customerId) {
  const cached = readWishlistCache(customerId).map(wishlistItemGid);

  const pairs = new Map();
  document.querySelectorAll('.wishlist_fav[data-product-id]').forEach((el) => {
    const id = el.dataset.productId;
    if (!pairs.has(id)) pairs.set(id, {});
    pairs.get(id)[el.dataset.action] = el;
  });

  pairs.forEach((pair) => {
    if (!pair.add || !pair.remove) return;
    const gid = `gid://shopify/Product/${pair.add.dataset.productId}`;
    const inWishlist = cached.includes(gid);
    pair.add.style.display = inWishlist ? 'none' : 'block';
    pair.remove.style.display = inWishlist ? 'block' : 'none';
  });
}

// Construit la grille de la page wishlist pour un invité à partir du cache local
// (titre/image/lien capturés au moment du clic sur le cœur, pas d'appel API).
function renderGuestWishlistGrid() {
  const grid = document.getElementById('guestProductGrid');
  const emptyState = document.getElementById('wishlistGuestEmptyState');
  if (!grid) return;

  const items = readWishlistCache(null).filter((item) => typeof item === 'object');

  grid.innerHTML = '';

  if (items.length === 0) {
    if (emptyState) emptyState.style.display = '';
    return;
  }

  if (emptyState) emptyState.style.display = 'none';

  items.forEach((item) => {
    const li = document.createElement('li');
    li.className = 'grid__item wishlist-guest-card';

    const link = document.createElement('a');
    link.href = item.url;
    link.className = 'wishlist-guest-card__link';

    const img = document.createElement('img');
    img.src = item.image;
    img.alt = item.title;
    img.loading = 'lazy';
    img.className = 'wishlist-guest-card__image';

    const title = document.createElement('p');
    title.className = 'wishlist-guest-card__title';
    title.textContent = item.title;

    link.appendChild(img);
    link.appendChild(title);

    if (item.price) {
      const price = document.createElement('p');
      price.className = 'wishlist-guest-card__price';
      price.textContent = item.price;
      link.appendChild(price);
    }

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'wishlist_fav';
    removeBtn.setAttribute('aria-label', 'Retirer de la wishlist');
    removeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16.0108 2.25024C19.3658 2.29879 22.75 5.03763 22.75 9.00024C22.75 15.0192 16.9805 19.348 12 21.8381C7.01954 19.348 1.25003 15.0192 1.25003 9.00024C1.25008 5.04637 4.62683 2.25024 8.00003 2.25024C9.37528 2.25025 10.8597 2.64674 11.9981 3.80981C13.128 2.64449 14.5981 2.22982 16.0108 2.25024Z" fill="#040037"/></svg>';
    removeBtn.addEventListener('click', () => {
      const next = readWishlistCache(null).filter((i) => wishlistItemGid(i) !== item.gid);
      writeWishlistCache(null, next);
      renderGuestWishlistGrid();
    });

    li.appendChild(link);
    li.appendChild(removeBtn);
    grid.appendChild(li);
  });
}

// Reprend la wishlist locale constituée avant connexion et la pousse sur le compte
// du client qui vient de se connecter.
//
// Traitement un par un, en séquentiel (pas Promise.all) : le backend fait un cycle
// lecture-modification-écriture sur le metafield, donc des appels en parallèle
// s'écrasent mutuellement et perdent des produits.
//
// Chaque produit n'est retiré de kiabi_wishlist_guest qu'une fois confirmé (200)
// par le serveur. Si la fusion est interrompue en cours de route (onglet fermé,
// erreur réseau), les produits pas encore confirmés restent dans le cache invité
// et seront retentés au prochain chargement de page, au lieu d'être perdus.
async function mergeGuestWishlist(customerId, wishlistUrl) {
  const guestWishlist = readWishlistCache(null);
  if (guestWishlist.length === 0) return;

  for (const item of guestWishlist) {
    const gid = wishlistItemGid(item);

    try {
      const r = await fetch(wishlistUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: gid, action: 'add' })
      });

      if (!r.ok) continue;

      const data = await r.json().catch(() => null);
      if (data && Array.isArray(data.wishlist)) {
        writeWishlistCache(customerId, data.wishlist);
      }

      const remaining = readWishlistCache(null).filter((i) => wishlistItemGid(i) !== gid);
      writeWishlistCache(null, remaining);
    } catch (err) {
      console.error(err);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const wishlistConfigEl = document.getElementById('wishlistConfig');
  if (!wishlistConfigEl) return;

  const wishlistUrl = wishlistConfigEl.dataset.url;
  const customerId = wishlistConfigEl.dataset.customerId;

  // Corrige l'état rendu par Liquid (retard de propagation des metafields côté
  // client connecté, ou wishlist purement locale côté invité), puis fusionne la
  // wishlist invité éventuelle dès qu'un client connecté est détecté.
  const ready = customerId ? mergeGuestWishlist(customerId, wishlistUrl) : Promise.resolve();
  ready.finally(() => applyWishlistCache(customerId));

  bindWishlistGuestModalDismiss();

  // Invité qui ouvre la page wishlist : popup à chaque fois, et affichage de sa
  // wishlist locale (titre/image/lien capturés au clic, aucun appel API).
  if (!customerId && window.location.pathname.endsWith('/pages/wishlist')) {
    showWishlistGuestModal();
    renderGuestWishlistGrid();
  }

  document.querySelectorAll('.wishlist_fav').forEach((btn) => {
    btn.addEventListener('click', async (event) => {
      const element = event.currentTarget;

      if (element.dataset.disabled === 'true') return;

      const other = element.parentElement.querySelector(
        `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
      );

      element.dataset.disabled = 'true';
      element.classList.add('is-loading');

      if (other) {
        other.dataset.disabled = 'true';
        other.classList.add('is-loading');
        element.style.display = 'none';
        other.style.display = 'block';
        other.classList.add('wishlist-pop');
        other.addEventListener('animationend', () => other.classList.remove('wishlist-pop'), { once: true });
      }

      if (!customerId) {
        // Non connecté : wishlist purement locale, aucun appel API.
        toggleGuestWishlistCache(element, element.dataset.action);
        if (element.dataset.action === 'add') maybeShowWishlistGuestModal();
        element.dataset.disabled = 'false';
        element.classList.remove('is-loading');
        if (other) {
          other.dataset.disabled = 'false';
          other.classList.remove('is-loading');
        }
        return;
      }

      try {
        const r = await fetch(wishlistUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: element.dataset.productId,
            action: element.dataset.action
          })
        });

        if (r.ok) {
          const data = await r.json().catch(() => null);
          if (data && Array.isArray(data.wishlist)) {
            writeWishlistCache(customerId, data.wishlist);
          }
        } else if (other) {
          other.style.display = 'none';
          element.style.display = 'block';
        }
      } catch (err) {
        console.error(err);
        if (other) {
          other.style.display = 'none';
          element.style.display = 'block';
        }
      } finally {
        element.dataset.disabled = 'false';
        element.classList.remove('is-loading');
        if (other) {
          other.dataset.disabled = 'false';
          other.classList.remove('is-loading');
        }
        if (window.location.pathname.endsWith('/pages/wishlist')) {
          element.closest('.grid__item')?.remove();
          const grid = document.getElementById('product-grid');
          const emptyState = document.getElementById('wishlistEmptyState');
          if (grid && emptyState && grid.querySelectorAll('.grid__item').length === 0) {
            emptyState.style.display = '';
          }
        }
      }
    });
  });
});
